/** Plain clicks stay in the app; modified clicks open the link like any other (new tab, copy address). */
export function inApp(event: React.MouseEvent): boolean {
  return event.button === 0 && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey;
}

interface AppLinkProps extends Omit<React.AnchorHTMLAttributes<HTMLAnchorElement>, 'href' | 'onClick'> {
  href: string;
  onNavigate: (url: string) => void;
}

/** A real link to an address of the app, so browser history and new tabs work. */
export function AppLink({ href, onNavigate, children, ...rest }: AppLinkProps): React.JSX.Element {
  return (
    <a
      {...rest}
      href={href}
      onClick={(event) => {
        if (!inApp(event)) return;
        event.preventDefault();
        onNavigate(href);
      }}
    >
      {children}
    </a>
  );
}
